<section class="wraper-sub">
  <div class="revisons-m progress-request">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Progress Requests</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m">
              <input type="text" name="search" [(ngModel)]="searchParams.email" (change)="rerender()" placeholder="Search by Email">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"  (click)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
                <ng-select
                    [items]="statusArr"
                    bindLabel="name"
                    bindValue="value"
                    placeholder="Status"
                    [(ngModel)]="searchParams.status"
                    [ngModelOptions]="{standalone: true}"
                    [searchable]="false"
                    [clearable]="true"
                    (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
    					        {{ item.name }}
    					    </ng-template>
                </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>S#</th>
              <th>Order ID</th>
              <th>Client Info</th>
              <th>Request Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{indx + 1}}</td>
                <td><a class="id" href="javascript:;" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>
                <td>
                  <p>{{ lead.user_name }}</p>
                  <p>{{ lead.user_phone }}</p>
                  <p>{{ lead.user_email }}</p>
                </td>
                <td>
                    <p *ngIf="lead.date == '0000-00-00 00:00:00'">-</p>
                    <ng-container *ngIf="lead.date != '0000-00-00 00:00:00'">
                        <p class="time-done">{{ lead.date | date }}</p>
                        <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                    </ng-container>
                </td>
                <td>
                  <div class="fields-m disposition-open select-m" [ngClass]="{'pending': lead.status == 0}">
                      <ng-select
                        [items]          = "statusArr"
                        placeholder      = "Status"
                        [(ngModel)]      = "lead.status"
                        [ngModelOptions] = "{standalone: true}"
                        [searchable]     = "false"
                        [clearable]      = "false"
                        bindLabel        = "name"
                        bindValue        = "value"
                        (change)         = "updateStatus(lead, indx)"
                        >
                        <ng-template ng-label-tmp let-item="item">
                          {{ item.name }}

                          <!-- <i class="fa fa-spinner fa-spin pull-right" *ngIf="lead.updatingStatus"></i> -->
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>
                  </div>
                </td>
              </tr>
            </tbody>
        </ng-container>

        </table>
      </div>
    </div>
  </div>
</section>
